import { createSlice } from "@reduxjs/toolkit";
import { initGraphSemaforo, loadings } from "../../../types/initStore/initGeneral";

const initialState = {
	pieChart: [],
	selectDateYear: "",
	projectCategories: { name: "test", children: [] },
	projectCategoriesAll: { name: "test", children: [] },
	datesCategories: [],
	projectSize: [],
	projectSizeAll: [],
	datesSize: [],
	projectLeaders: { name: "test", children: [] },
	projectLeadersAll: { name: "test", children: [] },
	datesLeaders: [],
	loadings: loadings,
	graphInternal: [],
	graphAreas: {
		pie: [],
		bar: [],
		keys: [],
	},
	graphSemaforo: initGraphSemaforo,
	errorGraph: false,
};

export const isGeneralSlice = createSlice({
	name: "general",
	// estado inicial definido en la parte superior line:3
	initialState,
	// todas las acciones que puden modificar el store
	reducers: {
		setLoading: (state, { payload }) => {
			state.loadings = payload;
		},
		setPieChart: (state, { payload }) => {
			state.pieChart = payload;
		},
		setProjectCategories: (state, { payload }) => {
			state.projectCategories = payload;
		},
		setProjectSize: (state, { payload }) => {
			state.projectSize = payload;
		},
		setProjectLeaders: (state, { payload }) => {
			state.projectLeaders = payload;
		},
		setProjectCategoriesAll: (state, { payload }) => {
			state.projectCategoriesAll = payload.projectCategoriesAll;
			state.datesCategories = payload.datesCategories;
		},
		setProjectSizeAll: (state, { payload }) => {
			state.projectSizeAll = payload.projectSizeAll;
			state.datesSize = payload.datesSize;
		},
		setProjectLeadersAll: (state, { payload }) => {
			state.projectLeadersAll = payload.projectLeadersAll;
			state.datesLeaders = payload.datesLeaders;
		},
		setGraphInternal: (state, { payload }) => {
			state.graphInternal = payload;
		},
		setGraphAreas: (state, { payload }) => {
			state.graphAreas = payload;
		},
		setErrorGraph: (state, { payload }) => {
			state.errorGraph = payload;
		},
		setGraphSemaforo: (state, { payload }) => {
			state.graphSemaforo = payload;
		},
	},
});

export const {
	setLoading,
	setPieChart,
	setProjectCategories,
	setProjectSize,
	setProjectLeaders,
	setProjectCategoriesAll,
	setProjectSizeAll,
	setProjectLeadersAll,
	setGraphInternal,
	setGraphAreas,
	setErrorGraph,
	setGraphBarArea,
	setGraphSemaforo,
} = isGeneralSlice.actions;
